module.exports = __webpack_public_path__ + "img/healthy.b15a3ef0.jpg";